"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _EnvironmentProvider = require("./EnvironmentProvider");
Object.keys(_EnvironmentProvider).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _EnvironmentProvider[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _EnvironmentProvider[key];
    }
  });
});
var _environmentContext = require("./environmentContext");
Object.keys(_environmentContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _environmentContext[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _environmentContext[key];
    }
  });
});
var _hooks = require("./hooks");
Object.keys(_hooks).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _hooks[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _hooks[key];
    }
  });
});
//# sourceMappingURL=index.js.map